import React, { useState } from "react";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { CircularProgress } from "@mui/material";
import RcsBulkMessageModal from "../RcsBulkMessage/RcsBulkMessageModal";

const RCSReplySuggestionMsg = ({ fetchData }) => {
  const [formData, setFormData] = useState({
    campaignID: "",
    contacts: "",
    messageText: "",
    replyButtonText: "",
    postbackData: "",
    bulkFileName: "",
  });

  const [errors, setErrors] = useState({});
  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isBulkUpload, setIsBulkUpload] = useState(false);
  const [bulkFileName, setBulkFileName] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");
  const { rcsAgentId } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [checking, setChecking] = useState(false);
  const [capabilityResult, setCapabilityResult] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [verifiedPhones, setVerifiedPhones] = useState([]);

  const [bulkType, setBulkType] = useState("");
  const [isNameRequired, setIsNameRequired] = useState(false);

  const formatContacts = (input) => {
    return input
      .split(",")
      .map((num) => num.trim())
      .filter((num) => /^\d{10}$/.test(num))
      .map((num) => `+91${num}`);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "contacts") {
      const cleanedValue = value.replace(/[^\d,]/g, "");
      const numbers = cleanedValue.split(",").map((num) => num.trim());
      const filteredNumbers = numbers.map((num) => num.slice(0, 10));
      const finalValue = filteredNumbers.join(",");

      setFormData((prev) => ({ ...prev, contacts: finalValue }));
      setCapabilityResult("");

      const validNumbers = filteredNumbers.filter((num) =>
        /^[6-9]\d{9}$/.test(num)
      );
      const allVerified =
        validNumbers.length > 0 &&
        validNumbers.every((num) => verifiedPhones.includes(num));
      setIsVerified(allVerified);
    } else if (name === "campaignID") {
      if (formData.campaignID === "" && value.trim() !== "") {
        const now = new Date();
        const hours = now.getHours();
        if (hours < 9 || hours >= 21) {
          CustomAlert({
            title: "Info",
            text: "RCS services are available only between 9 AM to 9 PM. Please try later.",
            icon: "info",
            confirmButtonText: "Okay",
            allowOutsideClick: false,
          });
          return;
        }
      }
      setFormData((prev) => ({ ...prev, [name]: value }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const fieldErrors = validateForm(name, value);
    setErrors((prev) => ({ ...prev, ...fieldErrors }));
  };

  const validateForm = (name, value) => {
    const newErrors = {};

    const campaignIDRegex = /^[a-zA-Z0-9 _-]{4,20}$/;
    if (name === "campaignID" || !name) {
      if (!formData.campaignID.trim()) {
        newErrors.campaignID = "Campaign ID is required";
      } else if (!campaignIDRegex.test(formData.campaignID.trim())) {
        newErrors.campaignID =
          "Campaign ID must be 4–20 alphanumeric characters with no spaces or special characters";
      }
    }

    if ((name === "contacts" || !name) && !isBulkUpload) {
      if (!formData.contacts.trim()) {
        newErrors.contacts = "Contacts are required";
      } else {
        const numbers = formData.contacts
          .split(",")
          .map((num) => num.trim())
          .filter((num) => num !== "");
        const invalid = numbers.filter((num) => !/^[6-9]\d{9}$/.test(num));
        if (invalid.length > 0) {
          newErrors.contacts =
            "Please enter a valid 10 digit number starting with either 6, 7, 8 or 9";
        }
      }
    }

    // if (name === "messageText" || !name) {
    //   if (!formData.messageText.trim()) {
    //     newErrors.messageText = "Message Text is required";
    //   } else if (formData.messageText.length < 5) {
    //     newErrors.messageText =
    //       "Message Text must be at least 5 characters long";
    //   }
    // }

    if (name === "messageText" || !name) {
      if (!formData.messageText.trim()) {
        newErrors.messageText = "Message Text is required";
      } else if (formData.messageText.length < 5) {
        newErrors.messageText =
          "Message Text must be at least 5 characters long";
      } else if (
        bulkType === "name" &&
        !/\{\{Name\}\}/.test(formData.messageText)
      ) {
        newErrors.messageText =
          "Message Text must include {{Name}} placeholder for Bulk Name upload";
      }
    }

    if (name === "replyButtonText" || !name) {
      if (!formData.replyButtonText.trim())
        newErrors.replyButtonText = "Reply Button Text is required";
    }

    if (name === "postbackData" || !name) {
      if (!formData.postbackData.trim())
        newErrors.postbackData = "Postback Data is required";
    }

    return newErrors;
  };

  const checkCapability = async () => {
    const contacts = formatContacts(formData.contacts);

    if (contacts.length === 0) {
      setCapabilityResult("⚠️ Please enter valid phone numbers");
      return false;
    }

    setChecking(true);
    try {
      const headers = {
        rcskey: rcsAgentId,
        "Content-Type": "application/json",
      };

      const payload = {
        PhoneNumbers: contacts,
        username: loggedInUserName,
      };

      console.log("Sending checkCapability request:", {
        url: apiList.CHECK_CAPABILITY,
        headers,
        payload,
      });

      const response = await axiosPostApi(
        apiList.CHECK_CAPABILITY,
        payload,
        headers
      );

      console.log("checkCapability response:", response?.data);

      if (
        response?.data?.meta?.status === "00" &&
        response?.data?.data?.length
      ) {
        setIsVerified(true);
        const newVerifiedNumbers = formData.contacts
          .split(",")
          .map((num) => num.trim())
          .filter((num) => /^[6-9]\d{9}$/.test(num));
        setVerifiedPhones((prev) => [
          ...new Set([...prev, ...newVerifiedNumbers]),
        ]);
        CustomAlert({
          title: "Success",
          text: response?.data?.meta?.message,
          icon: "success",
          confirmButtonText: "Okay",
          allowOutsideClick: false,
        });
      } else {
        setIsVerified(false);
        CustomAlert({
          title: "Error",
          text: response?.data?.meta?.message || "Capability check failed",
          icon: "error",
          confirmButtonText: "Okay",
          allowOutsideClick: false,
        });
      }
    } catch (err) {
      console.error("checkCapability error:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        headers: err.response?.headers,
      });
      setCapabilityResult(
        `⚠️ Network Error: ${err.message}${
          err.response?.status ? ` (Status: ${err.response.status})` : ""
        }`
      );
      setIsVerified(false);
    } finally {
      setChecking(false);
    }
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data?.balanceDetails));
          fetchData(1);
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  const handleCsvBulkUpload = () => {
    if (!csvFile) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        csv: "Please select a CSV file before uploading.",
      }));
      return;
    }
    const payload = {
      username: loggedInUserName,
      campaignID: formData.campaignID,
      contacts: [""],
      data: {
        content: {
          plainText: formData.messageText,
          suggestions: [
            {
              reply: {
                plainText: formData.replyButtonText,
                postBack: {
                  data: formData.postbackData,
                },
              },
            },
          ],
        },
      },
    };
    const formDataA = new FormData();
    formDataA.append("username", loggedInUserName);
    formDataA.append("rcsType", "PLAINTEXT_SUGGESTION");
    formDataA.append("rcsMessage", JSON.stringify(payload));
    formDataA.append("file", csvFile);
    formDataA.append("isNameRequired", isNameRequired);
    // formDataA.append("isNameRequired", false);

    bulkUpload(formDataA);
  };

  const bulkUpload = async (payload) => {
    try {
      const response = await axiosPostApi(
        apiList.RCS_UPLOAD_MOBILE_EXCEL,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response?.status === 200 && response?.data?.respCode === "00") {
        CustomAlert({
          title: "Success",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "Okay",
        }).then(() => {
          fetchDashboardData();
        });
        setFormData({
          campaignID: "",
          contacts: "",
          messageText: "",
          replyButtonText: "",
          postbackData: "",
          bulkFileName: "",
        });
        setBulkFileName(null);
        setIsBulkUpload(false);
        setIsVerified(false);
        setCapabilityResult("");
        setCsvFile(null);
        setBulkType("");
        setIsNameRequired(false);
      } else if (response?.data?.respCode === "05") {
        CustomAlert({
          title: "Info",
          text:
            response?.data?.message || "Invalid credentials. Please try again!",
          icon: "info",
          confirmButtonText: "Retry",
        });
      } else {
        CustomAlert({
          title: "Data Fetch Error",
          text:
            response?.data?.message ||
            "No data available for the specified criteria.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: `There was an error: ${error?.message}`,
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const now = new Date();
    const hours = now.getHours();
    if (hours < 9 || hours >= 21) {
      CustomAlert({
        title: "Info",
        text: "RCS services are available only between 9 AM to 9 PM. Please try again.",
        icon: "info",
        confirmButtonText: "Okay",
        allowOutsideClick: false,
      });
      return;
    }

    if (!isVerified && !isBulkUpload) {
      CustomAlert({
        title: "Info",
        text: "Please select either Check, Bulk or Bulk Name before proceeding.",
        icon: "info",
        confirmButtonText: "Okay",
        allowOutsideClick: false,
      });
      return;
    }

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      CustomAlert({
        title: "Error",
        text: "Please correct the errors in the form.",
        icon: "error",
        confirmButtonText: "Okay",
      });
      return;
    }

    if (isBulkUpload) {
      handleCsvBulkUpload();
    } else {
      try {
        setIsSubmitting(true);

        const payload = {
          campaignID: formData.campaignID,
          contacts: formatContacts(formData.contacts),
          data: {
            content: {
              plainText: formData.messageText,
              suggestions: [
                {
                  reply: {
                    plainText: formData.replyButtonText,
                    postBack: {
                      data: formData.postbackData,
                    },
                  },
                },
              ],
            },
          },
          username: loggedInUserName,
        };

        const headers = { rcskey: rcsAgentId };
        const response = await axiosPostApi(
          apiList.PLAIN_TEXT_SUGGESTION,
          payload,
          headers
        );

        const status = response?.data?.meta?.status;
        const message = response?.data?.meta?.message || "No message";

        if (status === "00") {
          CustomAlert({
            title: "Success",
            text: message,
            icon: "success",
            confirmButtonText: "Okay",
          }).then(() => {
            fetchDashboardData();
          });
          setFormData({
            campaignID: "",
            contacts: "",
            messageText: "",
            replyButtonText: "",
            postbackData: "",
            bulkFileName: "",
          });
          setIsVerified(false);
          setCapabilityResult("");
          setBulkFileName(null);
          setIsBulkUpload(false);
          setCsvFile(null);
          setBulkType("");
          setIsNameRequired(false);
        } else {
          CustomAlert({
            title: "Error",
            text: message,
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      } catch (error) {
        CustomAlert({
          title: "Error",
          text: "An error occurred while sending the message.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleRemoveFile = () => {
    setCsvFile(null);
    setBulkFileName(null);
    setIsBulkUpload(false);
    setErrors((prev) => ({ ...prev, csv: "" }));
  };

  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "sans-serif",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
        borderRadius: "12px",
        maxWidth: "900px",
        margin: "40px 0 40px 20px",
      }}
    >
      <h2 style={{ color: "#00b6CE", marginBottom: "20px", textAlign: "left" }}>
        Send RCS Reply Suggestion Message
      </h2>

      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        {/* Campaign ID and Contacts */}
        <div
          style={{
            display: "flex",
            gap: "20px",
            flexWrap: "wrap",
            width: "65%",
          }}
        >
          {/* Campaign ID */}
          <div style={{ flex: "1", minWidth: "200px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "5px",
                fontWeight: "bold",
                fontSize: "16px",
                textAlign: "left",
              }}
            >
              Campaign ID
            </label>
            <input
              type="text"
              name="campaignID"
              value={formData.campaignID}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Enter campaign ID"
              style={{
                padding: "8px 12px",
                borderRadius: "12px",
                border: errors.campaignID ? "1px solid red" : "1px solid #ccc",
                backgroundColor: "#f1f1f1",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                fontSize: "16px",
                width: "100%",
                height: "40px",
                outline: "none",
                transition: "all 0.3s ease",
              }}
            />
            {errors.campaignID && (
              <span style={{ color: "red", fontSize: "14px" }}>
                {errors.campaignID}
              </span>
            )}
          </div>

          {/* Contacts */}
          <div style={{ flex: "1", minWidth: "200px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "5px",
                fontWeight: "bold",
                fontSize: "16px",
                textAlign: "left",
              }}
            >
              Contacts
            </label>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="text"
                name="contacts"
                value={formData.contacts}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter phone number"
                disabled={isBulkUpload}
                style={{
                  flex: "1",
                  padding: "8px 12px",
                  borderRadius: "12px",
                  border: errors.contacts ? "1px solid red" : "1px solid #ccc",
                  backgroundColor: "#f1f1f1",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  fontSize: "16px",
                  height: "40px",
                  outline: "none",
                }}
              />
              <button
                type="button"
                onClick={checkCapability}
                disabled={
                  checking ||
                  !rcsAgentId ||
                  (formData.contacts &&
                    formData.contacts
                      .split(",")
                      .map((num) => num.trim())
                      .filter((num) => /^[6-9]\d{9}$/.test(num))
                      .every((num) => verifiedPhones.includes(num))) ||
                  isBulkUpload
                }
                title={
                  formData.contacts &&
                  formData.contacts
                    .split(",")
                    .map((num) => num.trim())
                    .filter((num) => /^[6-9]\d{9}$/.test(num))
                    .every((num) => verifiedPhones.includes(num))
                    ? "All numbers already verified"
                    : "Check phone numbers"
                }
                style={{
                  padding: "8px 12px",
                  borderRadius: "12px",
                  border: "none",
                  backgroundColor: "#00BCD4",
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "bold",
                  height: "40px",
                  width: "220px",
                  cursor:
                    checking ||
                    !rcsAgentId ||
                    (formData.contacts &&
                      formData.contacts
                        .split(",")
                        .map((num) => num.trim())
                        .filter((num) => /^[6-9]\d{9}$/.test(num))
                        .every((num) => verifiedPhones.includes(num))) ||
                    isBulkUpload
                      ? "not-allowed"
                      : "pointer",
                  opacity:
                    checking ||
                    !rcsAgentId ||
                    (formData.contacts &&
                      formData.contacts
                        .split(",")
                        .map((num) => num.trim())
                        .filter((num) => /^[6-9]\d{9}$/.test(num))
                        .every((num) => verifiedPhones.includes(num))) ||
                    isBulkUpload
                      ? 0.6
                      : 1,
                  filter: isBulkUpload ? "blur(0.6px)" : "none",
                }}
              >
                {checking ? (
                  <CircularProgress style={{ width: "20px", height: "20px" }} />
                ) : (
                  "Check"
                )}
              </button>
              <span>OR</span>
              <button
                type="button"
                onClick={() => {
                  setShowModal(true);
                  setBulkType("bulk");
                  setIsNameRequired(false);
                  setFormData((prev) => ({ ...prev, contacts: "" }));
                  setErrors((prev) => ({ ...prev, contacts: "" }));
                }}
                disabled={checking || !rcsAgentId || isVerified || bulkFileName}
                style={{
                  padding: "8px 12px",
                  borderRadius: "12px",
                  border: "none",
                  backgroundColor: "#00BCD4",
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "bold",
                  width: "90px",
                  height: "40px",
                  cursor:
                    checking || !rcsAgentId || isVerified || bulkFileName
                      ? "not-allowed"
                      : "pointer",
                  opacity:
                    checking || !rcsAgentId || isVerified || bulkFileName
                      ? 0.6
                      : 1,
                }}
              >
                Bulk
              </button>

              <span>OR</span>
              <button
                type="button"
                onClick={() => {
                  setShowModal(true);
                  setBulkType("name");
                  setIsNameRequired(true);
                  setFormData((prev) => ({ ...prev, contacts: "" }));
                  setErrors((prev) => ({ ...prev, contacts: "" }));
                }}
                disabled={checking || !rcsAgentId || isVerified || bulkFileName}
                style={{
                  padding: "8px 12px",
                  borderRadius: "12px",
                  border: "none",
                  backgroundColor: "#00BCD4",
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "bold",
                  minWidth: "120px",
                  height: "40px",
                  cursor:
                    checking || !rcsAgentId || isVerified || bulkFileName
                      ? "not-allowed"
                      : "pointer",
                  opacity:
                    checking || !rcsAgentId || isVerified || bulkFileName
                      ? 0.6
                      : 1,
                }}
              >
                Bulk Name
              </button>

              {/* <button
                onClick={() => {
                  setShowModal(true);
                  setFormData((prev) => ({ ...prev, contacts: "" }));
                  setErrors((prev) => ({ ...prev, contacts: "" }));
                }}
                type="button"
                style={{
                  padding: "8px 12px",
                  borderRadius: "12px",
                  border: "none",
                  backgroundColor: "#00BCD4",
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "bold",
                  width: "90px",
                  height: "40px",
                  cursor:
                    checking || !rcsAgentId || isVerified || bulkFileName
                      ? "not-allowed"
                      : "pointer",
                  opacity:
                    checking || !rcsAgentId || isVerified || bulkFileName
                      ? 0.6
                      : 1,
                  filter:
                    checking || !rcsAgentId || isVerified || bulkFileName
                      ? "blur(0.6px)"
                      : "none",
                }}
                disabled={checking || !rcsAgentId || isVerified || bulkFileName}
              >
                Bulk
              </button> */}
            </div>
            {isBulkUpload && bulkFileName && (
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    padding: "8px 12px",
                    borderRadius: "40px",
                    width: "fit-content",
                    backgroundColor: "#e0f7fa",
                    color: "#007c91",
                    fontSize: "16px",
                    height: "40px",
                    outline: "none",
                    transition: "box-shadow 0.2s ease-in-out",
                  }}
                >
                  {bulkFileName.name}
                </div>
                <button
                  type="button"
                  onClick={handleRemoveFile}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#007c91",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                  title="Remove file"
                >
                  ❌
                </button>
                {errors.csv && (
                  <span style={{ color: "red", fontSize: "14px" }}>
                    {errors.csv}
                  </span>
                )}
              </div>
            )}
            {isVerified &&
            formData.contacts
              .split(",")
              .map((num) => num.trim())
              .filter((num) => /^[6-9]\d{9}$/.test(num))
              .every((num) => verifiedPhones.includes(num)) ? (
              <span
                style={{ marginTop: "6px", color: "green", fontSize: "14px" }}
              >
                verified
              </span>
            ) : (
              capabilityResult && (
                <div
                  style={{ marginTop: "6px", color: "#333", fontSize: "14px" }}
                >
                  {capabilityResult}
                </div>
              )
            )}
            {errors.contacts && (
              <span style={{ color: "red", fontSize: "14px" }}>
                {errors.contacts}
              </span>
            )}
          </div>
        </div>

        {/* Reply Button Text and Postback Data */}
        <div
          style={{
            display: "flex",
            gap: "20px",
            flexWrap: "wrap",
            width: "100%",
          }}
        >
          {/* Reply Button Text */}
          <div style={{ flex: "1", minWidth: "200px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "5px",
                fontWeight: "bold",
                fontSize: "16px",
                textAlign: "left",
              }}
            >
              Reply Button Text
            </label>
            <input
              type="text"
              name="replyButtonText"
              value={formData.replyButtonText}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Enter Reply Button Text"
              style={{
                padding: "8px 12px",
                borderRadius: "12px",
                border: errors.replyButtonText
                  ? "1px solid red"
                  : "1px solid #ccc",
                backgroundColor: "#f1f1f1",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                fontSize: "16px",
                width: "100%",
                height: "40px",
                outline: "none",
                transition: "all 0.3s ease",
              }}
            />
            {errors.replyButtonText && (
              <span style={{ color: "red", fontSize: "14px" }}>
                {errors.replyButtonText}
              </span>
            )}
          </div>

          {/* Postback Data */}
          <div style={{ flex: "1", minWidth: "200px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "5px",
                fontWeight: "bold",
                fontSize: "16px",
                textAlign: "left",
              }}
            >
              Postback Data
            </label>
            <input
              type="text"
              name="postbackData"
              value={formData.postbackData}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Enter Postback Data"
              style={{
                padding: "8px 12px",
                borderRadius: "12px",
                border: errors.postbackData
                  ? "1px solid red"
                  : "1px solid #ccc",
                backgroundColor: "#f1f1f1",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                fontSize: "16px",
                width: "100%",
                height: "40px",
                outline: "none",
                transition: "all 0.3s ease",
              }}
            />
            {errors.postbackData && (
              <span style={{ color: "red", fontSize: "14px" }}>
                {errors.postbackData}
              </span>
            )}
          </div>
        </div>

        {/* Plain Text Message */}
        <div style={{ width: "100%" }}>
          <label
            style={{
              display: "block",
              marginBottom: "5px",
              fontWeight: "bold",
              fontSize: "16px",
              textAlign: "left",
            }}
          >
            Plain Text Message
          </label>
          <textarea
            name="messageText"
            value={formData.messageText}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Enter message text (max 50 characters)"
            style={{
              padding: "8px 12px",
              borderRadius: "12px",
              border: errors.messageText ? "1px solid red" : "1px solid #ccc",
              backgroundColor: "#f1f1f1",
              fontSize: "16px",
              width: "100%",
              minHeight: "100px",
              resize: "vertical",
              outline: "none",
            }}
          />
          {errors.messageText && (
            <span style={{ color: "red", fontSize: "14px" }}>
              {errors.messageText}
            </span>
          )}
        </div>

        {/* Submit Button Centered */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            type="submit"
            disabled={isSubmitting}
            style={{
              backgroundColor: isHovered || isActive ? "#ffffff" : "#00BCD4",
              color: isHovered || isActive ? "#00B6CE" : "#ffffff",
              border: isHovered || isActive ? "1px solid #00B6CE" : "none",
              padding: "12px 36px",
              fontSize: "16px",
              fontWeight: "600",
              borderRadius: "999px",
              cursor: isSubmitting ? "not-allowed" : "pointer",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              transition:
                "transform 0.1s ease-in-out, background-color 0.3s, color 0.3s, border 0.3s",
              alignSelf: "center",
              marginTop: "7px",
              transform: isActive ? "scale(0.95)" : "scale(1)",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onMouseDown={() => setIsActive(true)}
            onMouseUp={() => setIsActive(false)}
          >
            Send
          </button>
        </div>
      </form>
      <RcsBulkMessageModal
        show={showModal}
        handleClose={handleCloseModal}
        activeTab="PLAINTEXT_SUGGESTION"
        setIsBulkUpload={setIsBulkUpload}
        setBulkFileName={setBulkFileName}
        setCsvFile={setCsvFile}
        csvFile={csvFile}
        bulkType={bulkType}
      />
    </div>
  );
};

export default RCSReplySuggestionMsg;
